import{
GET_RENEWAL_START,
GET_RENEWAL_SUCCESS,
GET_RENEWAL_FAILURE,
GET_RENEWAL_RESET, 
FIND_RENEWAL_START,
FIND_RENEWAL_SUCCESS,
FIND_RENEWAL_FAILURE,
FIND_RENEWAL_RESET,
GETALL_RENEWAL_TRIGGER,
GETALL_RENEWAL_TRIGGER_SUCCESS,
GETALL_RENEWAL_TRIGGER_FAILED,
CREATE_RENEWAL_TRIGGER,
CREATE_RENEWAL_TRIGGER_SUCCESS,
CREATE_RENEWAL_TRIGGER_FAILED,
UPDATE_RENEWAL_TRIGGER,
UPDATE_RENEWAL_TRIGGER_SUCCESS,
UPDATE_RENEWAL_TRIGGER_FAILED, 
WHATSAPP_RENEWAL_MESSAGE,
WHATSAPP_RENEWAL_MESSAGE_SUCCESS,
WHATSAPP_RENEWAL_MESSAGE_FAILED,
} from "./actiontypes"

export const getRenewalStart =()  => {
    return {
      type: GET_RENEWAL_START,
    }
  }
  
  export const getRenewalSuccess =(payload) => {
    return {
      type: GET_RENEWAL_SUCCESS,
     payload,
    }
  }
  
  export const getRenewalFailure = error => {
    return {
      type: GET_RENEWAL_FAILURE,
      payload:error,
    }
  }
  export const getRenewalReset = () => {
    return {
      type: GET_RENEWAL_RESET,
    }
  }
  
  
export const findRenewalStart =(payload)  => {
  return {
    type: FIND_RENEWAL_START,
    payload,
  }
}

export const findRenewalSuccess =(payload) => {
  return {
    type: FIND_RENEWAL_SUCCESS,
   payload,
  }
}

export const findRenewalFailure = error => {
  return {
    type: FIND_RENEWAL_FAILURE,
    payload:error,
  }
}
export const findRenewalReset = () => {
  return {
    type: FIND_RENEWAL_RESET,
  }
}

export const getAllRenewalTrigger = () =>{
  return{
    type: GETALL_RENEWAL_TRIGGER
  }
}
export const getAllRenewalTriggerSuccess = (payload) =>{
  return{
    type: GETALL_RENEWAL_TRIGGER_SUCCESS,
    payload
  }
}
export const getAllRenewalTriggerFailed = (payload) =>{
  return{
    type: GETALL_RENEWAL_TRIGGER_FAILED,
    payload
  }
}

export const createRenewalTrigger = (payload) =>{
  return{
    type: CREATE_RENEWAL_TRIGGER,
    payload
  }
}


export const createRenewalTriggerSuccess = (payload) =>{
  return{
    type: CREATE_RENEWAL_TRIGGER_SUCCESS,
    payload
  }
}

export const createRenewalTriggerFailed = (payload) =>{
  return{
    type: CREATE_RENEWAL_TRIGGER_FAILED,
    payload
  }
}



export const updateRenewalTrigger = (payload) =>{
  return{
    type: UPDATE_RENEWAL_TRIGGER,
    payload
  }
}


export const updateRenewalTriggerSuccess = (payload) =>{
  return{
    type: UPDATE_RENEWAL_TRIGGER_SUCCESS,
    payload
  }
}

export const updateRenewalTriggerFailed = (payload) =>{
  return{
    type: UPDATE_RENEWAL_TRIGGER_FAILED,
    payload
  }
}

export const whatsAppRenewalMessage = (payload) =>{
  return{
    type: WHATSAPP_RENEWAL_MESSAGE,
    payload
  }
}

export const whatsAppRenewalMessageSuccess = payload =>{
  return{
    type: WHATSAPP_RENEWAL_MESSAGE_SUCCESS,
    payload
  }
}

export const whatsAppRenewalMessageFailed = payload =>{
  return{
    type: WHATSAPP_RENEWAL_MESSAGE_FAILED,
    payload
  }
}